
<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
      <div class="text-xs-left f-17 text-capitalize">Purchased HEYWAY Products</div>
    </v-toolbar>
    <!--<a :href="`#/adminprofile`"><v-icon class="text-grey right pa-3">edit</v-icon></a>-->
    <!--<p class="text-xs-left f-15 font-weight-bold pb-0">Current Active Product</p>-->
    <v-layout row wrap class="mt-2" v-if="Clubs.admin_package">
      <v-flex d-flex lg4 sm6 xs12>
        <v-card class="select-pack-card pa-2 shadow-1 card-r ">
          <v-toolbar class="tow-clor-grey mb-2 card-r shadow-1 pl-3 text-white">
            <div class="text-xs-left f-15">Current Active Product</div>
          </v-toolbar>
          <div class="f-20 text-xs-center font-weight-bold ">{{Clubs.admin_package.name}}</div>
          <v-layout xs12>
            <v-flex xs12 class="text-xs-justify grey--text">
              <p class="f-14">{{Clubs.admin_package.description}}</p>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 blue-grey--text">Duration</div>
            </v-flex>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 text-xs-right mb-2">{{Clubs.admin_package.duration}} Days</div>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 blue-grey--text ">Price</div>
            </v-flex>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 text-xs-right mb-2">DKK {{Clubs.admin_package.cost}}</div>
            </v-flex>
          </v-layout>

        </v-card>
      </v-flex>
      <v-flex d-flex lg8 sm6 xs12 v-if="Clubs.subscription">
        <v-card class="pa-2 text-xs-left white card-r shadow-1">
          <v-toolbar class="tow-clor-grey mb-2 card-r shadow-1 pl-3 text-white">
            <div class="text-xs-left f-15">30 Days Renewal Details of this driver product</div>
          </v-toolbar>
          <!--<p class="text-xs-left f-15 font-weight-bold  ">30 Days Renewal Details of this driver product</p>-->
          <p>
            Getting a driving app is considered to be a life-changing moment as you get your very own license to drivearound with your favourite set of wheels on the road. Though after a while, you would not give your driving license much of an importance and would easily consider it an extraneous property, you can never really drive your vehicle on Indian roads without carrying one, as driving without a license is an offence in India. Also, the time and energy invested by you in procuring a driving license is not to be easily forgotten.
            <!-- {{Clubs.admin_package.description}} -->
          </p>
          <p class="text-xs-left f-15 font-weight-bold ">Product Duration</p>
          <div class="text-xs-left f-15"><span class="font-weight-bold">
                              Start Date :
                          </span>{{Clubs.subscription.start_date}}</div>
          <div class="text-xs-left f-15 pb-2 "><span class="font-weight-bold">
                               Expire Date :
                           </span>{{Clubs.subscription.expiry_date}}</div>

          <p>
            Please review the following tips before you cancel: <br>

            We’ll only issue a refund if you’re cancelling an annual driver subscription within the subscription’s first 14 days.
            Your site content is marked for deletion 30 days after you cancel your site. Before cancelling, you can check and get all of your data.
            It's not possible move a website subscription from one site to another. If you're cancelling your driver subscription so you can not use a different site in its place, It will auto renew after 30 days with the same purchased driver product.
          </p>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex row wrap v-else="Clubs.admin_package">
      <v-alert
        :value="true"
        type="info">
        There is no current active Subscriptions
      </v-alert>
    </v-flex>
    <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 mt-2 text-white">
      <div class="text-xs-left f-17 text-capitalize">Discover new products</div>
    </v-toolbar>
    <v-layout row wrap class="mt-2">
      <v-flex d-flex lg4 sm6 xs12 v-for="(i,index) in Products" :key="index">
        <v-card class="white pa-3 shadow-1 card-r ">
          <div class="f-20 text-xs-center font-weight-bold ">{{i.name}}</div>
          <!-- <div  class="text-xs-center f-30 font-weight-bold blue-grey--text">Classes</div> -->
          <v-layout xs12>
            <v-flex xs12 class="text-xs-justify grey--text">
              <p class="f-14">{{i.description}}</p>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 blue-grey--text ">Duration</div>
            </v-flex>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 text-xs-right mb-2">30 Days</div>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0">
              <div class="font-weight-bold f-15 blue-grey--text">Price</div>
            </v-flex>
            <v-flex xs6 class="text-xs-justify pt-0 pb-0 ">
              <div class="font-weight-bold f-15 text-xs-right mb-2">${{i.cost}}</div>
            </v-flex>
          </v-layout>
          <v-layout xs12>

            <v-flex xs6 class="text-xs-right pa-0">

            </v-flex>

          </v-layout>
          <!--<v-btn class="no-shadow card-r w-100 ma-0 primary text--white btnM">Select</v-btn>-->
          <v-btn v-bind:to="'/changepackage/'+i.id" class="card-r w-100 ma-0 primary darken-2 text--white btnM">Buy</v-btn>

        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  /* eslint-disable */
  import { mapState, dispatch } from 'vuex';
  import Signup2 from "@/components/auth/Signup2.vue";
  export default {
    name: "AddNewStudent",
    data: () => ({
    }),
    created() {
      // debugger
      Store.dispatch("Clubs/getAdminClub").then(res => {
      });
      Store.dispatch("Products/getAllProducts").then(res => {
      });

    },

    components: {
      Signup2

    },
    computed: {
      ...mapState({
        Clubs: clubs => Store.state.Clubs.clubs,
        Products: Products => Store.state.Products.Products
      })
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/profile/admin/PurchasedPackage.vue